import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';
import { Button } from './ui/button';

const COOKIE_CONSENT_KEY = 'seafarer_cookie_consent';

export const getCookieConsent = () => {
  try {
    return localStorage.getItem(COOKIE_CONSENT_KEY);
  } catch (err) {
    return null;
  }
};

export const initAnalytics = () => {
  if (getCookieConsent() === 'accepted' && window.posthog) {
    window.posthog.opt_in_capturing();
  }
};

export const disableAnalytics = () => {
  if (window.posthog) {
    window.posthog.opt_out_capturing();
  }
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getCookieConsent();
    if (consent === null) {
      setVisible(true);
    } else if (consent === 'accepted') {
      initAnalytics();
    } else {
      disableAnalytics();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    initAnalytics();
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    disableAnalytics();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] p-4 lg:pl-[272px] pointer-events-none" data-testid="cookie-consent-banner">
      <div className="max-w-2xl mx-auto bg-slate-800 border border-slate-600 rounded-xl shadow-2xl shadow-black/40 p-4 pointer-events-auto">
        <div className="flex items-start gap-3">
          <Shield className="h-5 w-5 text-amber-400 mt-0.5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-slate-300 leading-relaxed">
              We use essential cookies for authentication and optional analytics cookies (PostHog) to improve the app.
              Analytics are only enabled with your consent.{' '}
              <a href="/privacy" className="text-amber-400 hover:text-amber-300 underline">Privacy Policy</a>
            </p>
            <div className="flex items-center gap-2 mt-3">
              <Button
                size="sm"
                onClick={handleAccept}
                className="bg-amber-600 hover:bg-amber-700 text-white text-xs h-8 px-4"
                data-testid="cookie-accept-btn"
              >
                Accept All
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={handleDecline}
                className="border-slate-600 text-slate-400 hover:text-white text-xs h-8 px-4"
                data-testid="cookie-decline-btn"
              >
                Essential Only
              </Button>
            </div>
          </div>
          <button
            onClick={handleDecline}
            className="text-slate-500 hover:text-slate-300 flex-shrink-0"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
